module.exports = __webpack_public_path__ + "static/media/ReloadIcon_Dark.f0446829.svg";